module.exports = __webpack_public_path__ + "img/plus.e5c1b102.png";